import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DownloadSdk } from '../../../../sdks/download.sdk';
import { ProductionJob } from '@models/review/production-job.model';
import { BaseComponent } from '../../../base.component';
import { switchMap, takeUntil, timer } from 'rxjs';

@Component({
    selector: 'lex-download-production-dialog',
    templateUrl: './download-production-dialog.component.html',
    styleUrls: ['./download-production-dialog.component.scss'],
    standalone: false
})
export class DownloadProductionDialogComponent extends BaseComponent {
    public urls: string[] = null;
    public productionJob: ProductionJob;

    constructor(
        private dialogRef: MatDialogRef<DownloadProductionDialogComponent>,
        private downloadSdk: DownloadSdk,
        @Inject(MAT_DIALOG_DATA) data
    ) {
        super();
        this.productionJob = data.productionJob;
        timer(0, 10000).pipe(
            switchMap(() => {
                return this.downloadSdk.getProductionDownloadUrls(this.productionJob.productionJobId)
            }),
            takeUntil(this.destroy$)
        ).subscribe(response => this.urls = response?.downloadUrls || []);
    }
}
